import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';

function ModalEditar({ isOpen, onClose, onConfirm, mensagem, children, dados }) {

    const [data, setData] = useState(dados || {});

    useEffect(() => {
        setData(dados || {});
    }, [dados]);


    const handleSubmit = () => {
        onConfirm(data);
    }

    if (!isOpen) return null;

    return (
        <>
            <Modal show={isOpen} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{mensagem}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        {children}
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Cancelar
                    </Button>

                    <Button variant="danger" onClick={handleSubmit}>
                        Atualizar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalEditar;